<template>
  <div class="cardGroup">
    <slot />
  </div>
</template>

<style lang="sass">
.cardGroup
  width: 100%
  display: flex
  margin: -1rem
  flex-wrap: wrap
  .card
    margin: 1rem
  @media screen and (max-width: 767px)
    margin: -1rem 0
    .card
      margin: 1rem 0
</style>
